export default __webpack_public_path__ + "static/media/bg_11.c5eef5b3.png";